const outerLiveMapSection = document.querySelector('#festival-live-map');

if (outerLiveMapSection) {
    const configuredLiveMap = outerLiveMapSection.querySelector(
        '[data-festival-live-map][data-live-locations-url][data-festival-latitude][data-festival-longitude]'
    );

    if (configuredLiveMap) {
        outerLiveMapSection.removeAttribute('data-festival-live-map');
        outerLiveMapSection.setAttribute('data-festival-live-map-section', '');
    }
}
